<script>
  import { createEventDispatcher, onMount } from 'svelte';
  import { External, M } from '../external';
  import { showActivateAddonUI, getMarketingEmailsAddon, LABELS, ADDON_ORDER } from './Addons/addons';

  export let subscription;
  let enabledAddons = {};
  let hasAddons = false;
  let dispatch = createEventDispatcher();

  let showAddon = async (type) => {
    let subscriptionDetails = await showActivateAddonUI(type, subscription);
    if (subscriptionDetails) {
      dispatch('change', subscriptionDetails);
    }
  };

  let enabled = (type) => {
    if (type === 'MARKETING_EMAILS' && subscription.overchargeEmails) {
      return true;
    }
    return subscription.addons?.some(addon => addon.type === type);
  };

  let isToggleAddon = (type) => {
    return ['BANDWIDTH', 'ECOMMERCE', 'MARKETING_EMAILS'].includes(type);
  };

  onMount(() => {
    External.Website.addons.forEach(addon => {
      let enabled = enabledAddons[addon.type];
      if (!enabled) {
        enabled = {
          ...addon,
          numOfAddonsOfType: 0
        };
        enabledAddons[addon.type] = enabled;
      }
      enabled.numOfAddonsOfType++;
      enabled.value = Math.min(enabled.value, addon.value);
      enabled.monthlyPrice = Math.min(enabled.monthlyPrice, addon.monthlyPrice);
    });

    if (enabledAddons['EMAIL_MARKETING']) {
      enabledAddons['MARKETING_EMAILS'] = getMarketingEmailsAddon(subscription);
    }
    hasAddons = Object.keys(enabledAddons).length > 0;
  });
</script>
{#if hasAddons}
  <h2 class="col20 f-left f-28 gray-text mb-5">{M.ALL_ADDONS}</h2>
  <div class="chart-wrapper col20 f-left mt-15">
    {#each ADDON_ORDER as type}
      {#if enabledAddons[type]}
        <div class="addon-wrapper flex align-center">
          <div class="flex align-center">
            <div class="addon-icon mr-10">
              <img src={`${External.resources}/images/svg/addon-${type.toLowerCase()}.svg?v=${External.resourcesVersion}`} alt="" />
            </div>
            <h3>{LABELS[type]?.name || type}
              <span class="f-14 light-gray-text">
              {LABELS[type]?.newAddonPriceSummary(enabledAddons[type].monthlyPrice, subscription.currency, enabledAddons[type].numOfAddonsOfType > 1) || '-'}
          </span>
            </h3>
          </div>
          {#if isToggleAddon(type)}
            {#if enabled(type)}
              <a class="middle-button rounded-effect green with-icon checked-icon">{M.ENABLED}</a>
            {:else}
              <a on:click={() => showAddon(type)} class="middle-button rounded-effect green with-icon">{M.ENABLE}</a>
            {/if}
          {:else}
            <a on:click={() => showAddon(type)} class="middle-button rounded-effect green with-icon">{M.ADD}</a>
          {/if}
        </div>
      {/if}
    {/each}
  </div>
{/if}
